import React, { useRef } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  Button,
  ModalBody,
  UploadZone,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import LinkItem, { LinkEditValues } from './LinkItem';
import { SmtFile } from '../../../../../../../types/Form';

interface Props {
  onClose: () => void;
  value: SmtFile[];
  files?: File[];
  onRemove: (index: number) => void;
  handleUploads: (files: File[]) => void;
  onChange: (files: SmtFile[]) => void;
  supportedLinkFormats: string[];
  isEditable?: boolean;
}

const LinkInputUploadModal: React.FC<Props> = ({
  onClose,
  value,
  files = [],
  handleUploads,
  supportedLinkFormats,
  isEditable,
  onChange,
  onRemove,
}) => {
  const { t } = useTranslation();
  const linkItemRefs = useRef<Array<HTMLInputElement | null>>([]);
  const newValues: Record<number, LinkEditValues> = {};

  const handleSubmitAll = () => {
    linkItemRefs.current.forEach((ref) => ref?.click());
  };

  const handleEditAsync = (values: LinkEditValues, index: number) => {
    newValues[index] = values;

    if (Object.keys(newValues).length === value.length) {
      const updatedValues = value.map((item, i) => ({
        ...item,
        ...newValues[i],
      }));

      onChange(updatedValues);
      onClose();
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('PARTIES_DETAIL_TAB_DOCUMENTS_ACTION')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing="3" align="stretch">
            <UploadZone
              multiple
              onFilesAccepted={(files: File[]) => {
                handleUploads(files);
              }}
              accept={supportedLinkFormats}
            />
            {files.map((file, i) => (
              <LinkItem
                key={i + Boolean(value[i]?.filename).toString()}
                file={file}
                document={value[i]}
                onRemove={() => onRemove(i)}
                onSubmit={(values) => handleEditAsync(values, i)}
                alwaysOpen
                ref={(el) => (linkItemRefs.current[i] = el)}
              />
            ))}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleSubmitAll}>{t('SAVE')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LinkInputUploadModal;
